import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import { View } from '@react-pdf/renderer'

const Plan = ({ epcr, printedBy, anonymised }) => (
  <RecordSection title="Plan">
    <InfoLine label="Patient Outcome" value={epcr.plan.ptOutcome} />
    <InfoLine label="Plan" value={epcr.plan.planNotes} />
    {epcr.plan.destinationName && !anonymised && (
      <InfoLine
        label="Destination"
        value={`${epcr.plan.destinationName} (${epcr.plan.destinationType})`}
      />
    )}
    {epcr.plan.transportType && (
      <InfoLine label="Transport" value={epcr.plan.transportType} />
    )}
    {epcr.plan.transportSafetyFeatures.length > 0 && (
      <InfoLine
        label="Safety Features Used"
        value={epcr.plan.transportSafetyFeatures.join(', ')}
      />
    )}
    <InfoLine label="Advice Given" value={epcr.plan.adviceGiven} />
    {epcr.plan.leafletsProvided.length > 0 && (
      <InfoLine
        label="Leaflets Provided"
        value={epcr.plan.leafletsProvided.join(', ')}
      />
    )}
    <View
      style={{
        marginVertical: 5,
        borderBottomStyle: 'solid',
        borderColor: '#616161',
      }}
    />
    {!anonymised && (
      <InfoLine
        label="Completed By"
        value={
          epcr.review.completedByRecord?.name
            ? [
                epcr.review.completedByRecord.name,
                epcr.review.completedByRecord.clinicalRole &&
                  `(${epcr.review.completedByRecord.clinicalRole})`,
                epcr.review.completedByRecord.personType === 'Subcontractor' &&
                  '[Subcontractor]',
              ]
                .filter(Boolean)
                .join(' ')
            : `${epcr.review.completedBy?.firstName ?? ''} ${
                epcr.review.completedBy?.lastName ?? ''
              }`.trim()
        }
      />
    )}
    {epcr.review.currentOwner && !anonymised && (
      <InfoLine
        label="Record Owner"
        value={`${epcr.review.currentOwner.firstName ?? ''} ${
          epcr.review.currentOwner.lastName ?? ''
        }`}
      />
    )}
    <InfoLine label="Status" value={epcr.review.status} />
    {epcr.review.submittedTime && !anonymised && (
      <InfoLine
        label="Submitted"
        value={moment(epcr.review.submittedTime).format('DD/MM/YYYY HH:mm')}
      />
    )}
    <InfoLine
      label="Printed By"
      value={`${printedBy} at ${moment().format('HH:mm [on] DD/MM/YYYY')}`}
    />
  </RecordSection>
)

export default Plan
